import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-line-two-angle-point",
  "use": "icon-si-glyph-line-two-angle-point-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-line-two-angle-point\" id=\"icon-si-glyph-line-two-angle-point\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>974</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M7.938,0.938 L9.022,0.938 L9.022,2.063 L7.938,2.063 L7.938,0.938 L7.938,0.938 Z M9.021,15.062 L7.937,15.062 L7.937,13.937 L8.01,13.937 L8.01,13.948 L8.927,13.948 L8.927,13.937 L9.021,13.937 L9.021,15.062 L9.021,15.062 Z M9.959,13.041 L8.928,13.041 L8.928,3 L9.959,3 L9.959,0.041 L7,0.041 L7,3 L8.011,3 L8.011,13.041 L7,13.041 L7,16 L9.959,16 L9.959,13.041 L9.959,13.041 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-line-two-angle-point.svg
// module id = B6JB
// module chunks = 62